import { Empty, Select } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DataTable from "../../../common/components/DataTable/WhiteHeaderTable";
import { ExpandSVG } from "../../../common/components/icons/SVGIcon";
import Loading from "../../../common/components/Loading";
import {
  angio_condition_type,
  angio_condition_type_choice,
  search_cpt_code,
  setProcedureDetails,
  update_cpt_clinic_procedure_type,
} from "../../../store/actions";

let timer = null;

const MODIFIER_OPTIONS = [
  { value: "RT", label: "RT Right side" },
  { value: "LT", label: "LT Left side" },
  { value: "50", label: "50 Bilateral procedure" },
  { value: "TA", label: "TA Left great toe" },
  { value: "T1", label: "T1 Left second toe" },
  { value: "T2", label: "T2 Left third toe" },
  { value: "T3", label: "T3 Left fourth toe" },
  { value: "T4", label: "T4 Left fifth toe" },
  { value: "T5", label: "T5 Right great toe" },
  { value: "T6", label: "T6 Right second toe" },
  { value: "T7", label: "T7 Right third toe" },
  { value: "T8", label: "T8 Right fourth toe" },
  { value: "T9", label: "T9 Right fifth toe" },
  { value: "Q7", label: "One Class"},
  { value: "Q8", label: "Two Class"},
  { value: "Q9", label: "One Class"},
  { value: "25", label: "Significant" },
  { value: "24", label: "Unrelated" },
  { value: "59", label: "Distinct Procedural Service" },
  { value: "XS", label: "Separate Structure" },
  { value: "58", label: "Staged or Related Procedure" },
  { value: "78", label: "Unplanned Return to OR" },
  { value: "79", label: "Unrelated Procedure" },
  { value: "50", label: "Bilateral Procedure"},
  { value: "51", label: "Multiple Procedures"},
  { value: "GA", label: "Waver of Medicare"},
  { value: "GY", label: "Statutorily Medicare"},
  { value: "KX", label: "Requirement Medicare"},
];

const CptCodeLogic = ({ resource }) => {
  const cptCodesClinic = useSelector((state) => state.procedureDetail.cptCodesClinic);
  const selectData = useSelector((state) => state.common.searchCPT);
  const loadingSearchCPT = useSelector((state) => state.common.loadingSearchCPT);
  const angio_type_select_search = useSelector((state) => state.procedureDetail.angio_type_select_search);
  const loading_clinic_type_variable = useSelector((state) => state.procedureDetail.loading_clinic_type_variable);
  const detail_clinic_type = useSelector((state) => state.procedureDetail.detail_clinic_type);
  const angio_choice = useSelector((state) => state.procedureDetail.angio_choice);
  const dispatch = useDispatch();
  const variable = useSelector((state) => state.procedureDetail.clinicVariable);

  const [searchResult, setSearchResult] = useState([]);
  const [searchAnswer, setSearchAnswer] = useState([]);
  const [selectResult, setSelectResult] = useState([]);
  const [selectSearch, setSelectSearch] = useState(null);
  const [localLoading, setLocalLoading] = useState(false);
  const [focusState, setFocusState] = useState(false);
  const [IDRow, setIDRow] = useState(null);
  const [activeDelete, setActiveDelete] = useState([]);
  const [removableParent, setRemovableParent] = useState(-1);

  const handleModifierChange = async (value, indexICD) => {
    if (cptCodesClinic && cptCodesClinic[indexICD]) {
      cptCodesClinic[indexICD]["modifier"] = value;
      await dispatch(setProcedureDetails("cptCodesClinic", [...cptCodesClinic]));
    }
  };

  const handleChange = async (type, value, index, indexICD) => {
    if (cptCodesClinic && cptCodesClinic[indexICD]) {
      if (type === "cpt_code_id") {
        cptCodesClinic[indexICD]["cpt_code_id"] = value[0];
        await dispatch(setProcedureDetails("cptCodesClinic", [...cptCodesClinic]));
      } else {
        if (type == "icd_code") {
          cptCodesClinic[indexICD]["condition_serialize"][index]["icd_code"]["icd_code"] = value[1];
          cptCodesClinic[indexICD]["condition_serialize"][index]["icd_code"]["icd_name"] = value[2];
        } else {
          cptCodesClinic[indexICD]["condition_serialize"][index][type] = value === "THAN" && type === "operator" ? "THAN" : value;
        }
        await dispatch(setProcedureDetails("cptCodesClinic", [...cptCodesClinic]));
      }
    }
  };

  const handleChangeOperator = async (value, index, indexICD) => {
    const nextIndex = index + 1;
    if (cptCodesClinic[indexICD] && cptCodesClinic[indexICD]["condition_serialize"] && cptCodesClinic[indexICD]["condition_serialize"].length > 0) {
      const plan = cptCodesClinic[indexICD]["condition_serialize"][nextIndex];
      const paramNU = {
        variable_id: plan && typeof plan["variable_id"] != "undefined" ? plan["variable_id"] : "",
        variable_name: plan && typeof plan["variable_name"] != "undefined" ? plan["variable_name"] : "",
        answer: plan && typeof plan["answer"] != "undefined" ? plan["answer"] : "",
        comparison: plan && typeof plan["comparison"] != "undefined" ? plan["comparison"] : ">=",
        operator: plan && typeof plan["operator"] != "undefined" ? plan["operator"] : "",
      };
      const paramUN = {
        icd_code: { icd_code: "", icd_name: "" },
        variable_id: undefined,
        variable_name: undefined,
        answer: undefined,
        comparison: undefined,
        operator: undefined,
      };
      if (cptCodesClinic && cptCodesClinic[indexICD]) {
        if (value !== "THAN") {
          cptCodesClinic[indexICD]["condition_serialize"][index + 1] = {
            ...paramNU,
          };
          await dispatch(setProcedureDetails("cptCodesClinic", [...cptCodesClinic]));
        } else {
          const abc = cptCodesClinic[indexICD];
          abc["condition_serialize"].map((item, indexMap) => {
            if (indexMap > index) {
              abc["condition_serialize"][indexMap] = null;
            }
          });
          const check = abc["condition_serialize"].filter((item) => {
            if (item != null) {
              return item;
            }
          });
          cptCodesClinic[indexICD]["condition_serialize"] = [...check, paramUN];
          await dispatch(setProcedureDetails("cptCodesClinic", [...cptCodesClinic]));
        }
      }
    }
  };

  useEffect(() => {
    if (detail_clinic_type && Object.keys(detail_clinic_type).length > 0) {
      dispatch(setProcedureDetails("cptCodesClinic", detail_clinic_type?.cpt_rules ? detail_clinic_type?.cpt_rules : []));
    }
  }, [detail_clinic_type]);

  useEffect(() => {
    const selectMap = (angio_type_select_search || []).map((r) => {
      return { id: r?.id, name: r?.name };
    });
    const checkArrayChoice = (angio_choice || []).map((r) => {
      return { id: r?.id, name: r?.name };
    });
    const variableMap = (variable || []).map((r) => {
      return { id: r?.id, name: r?.variable_name };
    });
    setSearchAnswer([...checkArrayChoice]);
    setSearchResult([...selectMap, ...variableMap]);
  }, [angio_type_select_search, angio_choice, variable]);

  useEffect(() => {
    if (!localLoading) {
      setSelectResult([...selectData]);
    }
  }, [selectData]);

  useEffect(() => {
    setLocalLoading(true);
    clearTimeout(timer);
    timer = setTimeout(() => {
      dispatch(search_cpt_code(selectSearch, 1));
      setLocalLoading(false);
    }, 500);
  }, [selectSearch]);

  const removeProvider = async (index, indexICD) => {
    const checkCPTRow = { ...cptCodesClinic[indexICD] };
    let finalCptCodes = [...cptCodesClinic];
    if (checkCPTRow && checkCPTRow["condition_serialize"] && checkCPTRow["condition_serialize"].length > 1) {
      if (checkCPTRow["condition_serialize"][index].operator === "THAN" || checkCPTRow["condition_serialize"][index].operator === "") {
        checkCPTRow["condition_serialize"].splice(index, 2);
      } else {
        checkCPTRow["condition_serialize"].splice(index, 1);
      }
      const check = checkCPTRow["condition_serialize"].filter((item) => {
        if (item != null) {
          return item;
        }
      });
      if (check && check.length > 0) {
        finalCptCodes[indexICD]["condition_serialize"] = [...check];
      } else {
        finalCptCodes.splice(indexICD, 1);
      }
    } else {
      finalCptCodes[indexICD] = null;
      finalCptCodes = finalCptCodes.filter((r) => r != null);
    }
    const rulesPayload = finalCptCodes.map((r) => ({
      cpt_code_id: r?.cpt_code_id,
      modifier: r?.modifier,
      clinic_procedure_type_id: detail_clinic_type?.id,
      condition_serialize: r?.condition_serialize ? [...r?.condition_serialize] : [{}],
    }));
    await dispatch(setProcedureDetails("cptCodesClinic", [...finalCptCodes]));
    await dispatch(
      update_cpt_clinic_procedure_type(detail_clinic_type?.id, {
        rules: rulesPayload,
      })
    );
  };

  const update = async () => {
    if (cptCodesClinic && cptCodesClinic[IDRow] && cptCodesClinic[IDRow]["condition_serialize"]) {
      const arrayADD = (cptCodesClinic || []).map((r) => {
        return {
          cpt_code_id: r?.cpt_code_id,
          modifier: r?.modifier,
          clinic_procedure_type_id: detail_clinic_type?.id,
          condition_serialize: r?.condition_serialize ? [...r?.condition_serialize] : [{}],
        };
      });
      await dispatch(
        update_cpt_clinic_procedure_type(detail_clinic_type?.id, {
          rules: arrayADD,
        })
      );
    }
  };

  useEffect(() => {
    update();
  }, [cptCodesClinic]);

  useEffect(() => {
    dispatch(angio_condition_type());
  }, []);

  if (resource === null || resource === undefined) {
    return null;
  }

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {(cptCodesClinic || []).map((itemICD, indexICD) => {
        return (
          <div
            key={indexICD}
            onClick={() => {
              setIDRow(indexICD);
            }}
            style={{
              width: "100%",
              background: "rgb(219, 227, 238)",
              padding: "7px 0",
              marginBottom: "1rem",
            }}
          >
            <DataTable
              title="icd_code"
              hideHeader={true}
              sizeHeightFix={itemICD?.condition_serialize && itemICD?.condition_serialize.length > 1 ? itemICD?.condition_serialize.length * 40 : 40}
              isFixHeight={true}
              isOverFlow={true}
              isICD={true}
              hideHeaderHeight="0px"
              allActive={true}
              handleDelete={(value, index) => removeProvider(index, indexICD)}
              parentIndex={indexICD}
              handleActiveDelete={(val) => {
                const activeDeletes = [...activeDelete];
                activeDeletes[indexICD] = val;
                if (removableParent !== indexICD) {
                  activeDeletes[removableParent] = -1;
                  setRemovableParent(indexICD);
                } else {
                  if (val === -1) setRemovableParent(-1);
                }
                setActiveDelete(activeDeletes);
              }}
              activeParent={activeDelete[indexICD]}
              labels={["Variable", "Option", "Answer", "Operator"]}
              widths={["30%", "0%", "40%", "30%"]}
              columns={[
                { sortable: false, key: "variable" },
                { sortable: false, key: "option" },
                { sortable: false, key: "answer" },
                { sortable: false, key: "operator" },
              ]}
              rowData={(itemICD?.condition_serialize || []).map((item, index) => {
                let arrayAnswer = [];
                const answerCheck = (variable || []).find((r) => {
                  return r.variable_name == item?.variable_name?.name;
                });
                if (answerCheck) {
                  const allAnswerCheck = (answerCheck.answer || []).map((item, index) => {
                    return { id: item?.id, answer: item.answer };
                  });
                  arrayAnswer = [...allAnswerCheck];
                }
                return {
                  key: index,
                  disableDelete: typeof item?.operator === "undefined" && true,
                  fullsize: typeof item?.operator === "undefined" && true,
                  variable:
                    typeof item?.operator === "undefined" ? (
                      <Select
                        key={index}
                        showSearch
                        placeholder="Search ICD Code"
                        value={`${item?.icd_code?.icd_code} ${item?.icd_code?.icd_name}`}
                        onSearch={(value) => {
                          setSelectSearch(value);
                        }}
                        onDropdownVisibleChange={(open) => {
                          setFocusState(open);
                        }}
                        onBlur={() => {
                          setSelectSearch(null);
                        }}
                        autoClearSearchValue={false}
                        suffixIcon={<ExpandSVG />}
                        allowClear={false}
                        notFoundContent={
                          localLoading || loadingSearchCPT ? (
                            <div style={{ height: 100 }}>
                              <Loading />
                            </div>
                          ) : (
                            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                          )
                        }
                        onChange={(value) => {
                          handleChange("cpt_code_id", value, index, indexICD);
                          handleChange("icd_code", value, index, indexICD);
                        }}
                        style={{ width: "100%", borderBottom: 0 }}
                      >
                        {(selectResult || []).map((r, index) => (
                          <Select.Option key={r?.id} value={focusState ? [r?.id, r.code, r.short_desc] : `${r.code} ${r.short_desc}`}>
                            {r.code} {r.short_desc}
                          </Select.Option>
                        ))}
                      </Select>
                    ) : (
                      <Select
                        placeholder={"Variable"}
                        suffixIcon={<ExpandSVG />}
                        allowClear={false}
                        value={item?.variable_id}
                        onChange={(value) => {
                          handleChange("variable_id", value, index, indexICD);
                          handleChange(
                            "variable_name",
                            searchResult.find((r) => r?.id == value),
                            index,
                            indexICD
                          );
                        }}
                        style={{ width: "100%", borderBottom: 0 }}
                      >
                        {(searchResult || []).map((opt, index) => (
                          <Select.Option key={`variable-${index}-${opt?.id}`} value={opt?.id}>
                            {opt?.name}
                          </Select.Option>
                        ))}
                      </Select>
                    ),
                  option: typeof item?.operator === "undefined" ? "" : <span></span>,
                  answer:
                    typeof item?.operator === "undefined" ? (
                      ""
                    ) : (
                      <Select
                        placeholder={"Answer"}
                        suffixIcon={<ExpandSVG />}
                        allowClear={false}
                        value={item?.answer}
                        notFoundContent={loading_clinic_type_variable ? null : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}
                        onFocus={async () => {
                          setSearchAnswer([]);
                          if (item?.variable_id) {
                            await dispatch(angio_condition_type_choice(item?.variable_id));
                          }
                        }}
                        onChange={(value) => {
                          handleChange("answer", value, index, indexICD);
                        }}
                        style={{ width: "100%", borderBottom: 0 }}
                      >
                        {arrayAnswer && arrayAnswer.length > 0
                          ? arrayAnswer.map((opt) => (
                              <Select.Option key={`answer-${opt?.answer}`} value={opt?.answer}>
                                {opt?.answer}
                              </Select.Option>
                            ))
                          : (searchAnswer || []).map((opt) => (
                              <Select.Option key={`answer-${opt?.name}`} value={opt?.name}>
                                {opt?.name}
                              </Select.Option>
                            ))}
                      </Select>
                    ),
                  operator:
                    typeof item?.operator === "undefined" ? (
                      ""
                    ) : (
                      <Select
                        placeholder={"Operator"}
                        suffixIcon={<ExpandSVG />}
                        allowClear={false}
                        value={item?.operator || undefined}
                        onChange={(value) => {
                          handleChange("operator", value, index, indexICD);
                          handleChangeOperator(value, index, indexICD);
                        }}
                        style={{ width: "100%", borderBottom: 0 }}
                      >
                        {["OR", "AND", "THAN"].map((opt) => (
                          <Select.Option key={`operator-${opt}`} value={opt}>
                            {opt}
                          </Select.Option>
                        ))}
                      </Select>
                    ),
                };
              })}
            />
            <div style={{ padding: "7px 12px" }}>
              <Select
                placeholder="Select Modifier"
                suffixIcon={<ExpandSVG />}
                allowClear={true}
                value={itemICD?.modifier || undefined}
                onChange={(value) => {
                  handleModifierChange(value, indexICD);
                }}
                style={{ width: "100%", borderBottom: 0 }}
              >
                {MODIFIER_OPTIONS.map((opt) => (
                  <Select.Option key={`modifier-${opt.value}`} value={opt.value}>
                    {opt.label}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default CptCodeLogic;
